module.exports = __webpack_public_path__ + "img/loginimagen.790174cc.png";